const accordionButtons  = document.querySelectorAll(`.js--accordion-button`);
const accordionPanels   = document.querySelectorAll(`.css--accordion__panel`);

// This function takes an element and scrolls to it, if it's not visible
function scrollToTop(element) {
  // Only scroll if the element isn't on-screen,
  // otherwise it looks jerky
  if (!isInView(element)) {
    // Also get height of header to add to the offset;
    // it doesn't do much good to scroll to the button
    // if the button is covered up by the header
    let totalOffset = element.offsetTop;
    let headerOffset = document.querySelector('header').offsetHeight;
    console.log(headerOffset);
    totalOffset -= headerOffset;

    window.scroll({
      top: totalOffset,
      left: 0,
      behavior: 'smooth'
    });
  }
}

// This function checks if an element is visible
function isInView(element) {
  const rect = element.getBoundingClientRect();
  let verdict = (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );

  return verdict;
}

// Add event listeners to open/close Accordion panels on click to buttons
accordionButtons.forEach(button => {
  button.addEventListener(`click`, event => {
    // Get the panel for this button
    let thisPanel = button.nextElementSibling;

    // If this panel is open, close it
    if (button.classList.contains(`js--accordion-button--open`)) {
      button.classList.remove(`js--accordion-button--open`);
      thisPanel.classList.remove(`-is-active`);

    // Otherwise, open it!
    } else {
      // But first...
      let activeButtons = document.querySelectorAll(`.js--accordion-button--open`);
      // For every active button
      activeButtons.forEach(item => {
        let activePanel = item.nextElementSibling;
        // Deactive the button
        item.classList.remove(`js--accordion-button--open`);
        // And close its panel
        activePanel.classList.remove(`-is-active`)
      });

      // NOW open it!
      button.classList.add(`js--accordion-button--open`);
      thisPanel.classList.add(`-is-active`);

      // And scroll to the top of the button
      window.setTimeout(() => {
        scrollToTop(button);
      }, 300);
    }
  });
});
